// extracted by mini-css-extract-plugin
export default {"products":"Cs-z","card":"Ds-z","oosMessaging":"Es-z"};